import React from 'react';
import SkillsGrid from '../components/SkillsGrid';
import { useTheme } from '../contexts/ThemeContext';
import { useTranslation } from 'react-i18next';

const MySkills: React.FC = () => {
  const { theme } = useTheme();
  const { t } = useTranslation();
  const isModern = theme === 'modern';

  return (
    <section id="skills" className={`${isModern ? 'modern-section' : ''} py-12 sm:py-16 lg:py-20 min-h-screen w-full relative overflow-hidden flex flex-col justify-center items-center`}>
      {/* Neobrutalism decorative blobs */}
      {!isModern && (
        <div className="absolute inset-0 -z-10">
          <div className="hidden sm:block absolute top-20 right-20 w-16 h-16 bg-yellow-300 rounded-full mix-blend-multiply filter blur-sm opacity-40 animate-blob"></div>
          <div className="hidden sm:block absolute bottom-40 left-20 w-20 h-20 bg-purple-300 rounded-full mix-blend-multiply filter blur-sm opacity-40 animate-blob animation-delay-2000"></div>
          <div className="hidden md:block absolute top-1/2 left-10 w-12 h-12 bg-pink-300 rounded-full mix-blend-multiply filter blur-sm opacity-35 animate-blob animation-delay-4000"></div>
          <div className="hidden lg:block absolute top-10 left-1/3 w-14 h-14 bg-green-300 rounded-full mix-blend-multiply filter blur-sm opacity-25 animate-blob animation-delay-3000"></div>
        </div>
      )}

      <div className="flex flex-col items-center justify-center w-full max-w-7xl mx-auto px-3 sm:px-4 lg:px-6 xl:px-8 relative z-10 mt-16 sm:mt-20">
        {isModern ? (
          /* SCI-FI — SYSTEM CAPABILITY MATRIX HEADER */
          <header className="sf-skills-header w-full mb-10 sm:mb-12 lg:mb-14">
            <div className="sf-skills-header__strip">
              <span className="sf-skills-header__tag">SYS_CAPABILITIES</span>
              <span className="sf-dossier__sep">▌</span>
              <span className="sf-skills-header__matrix">MATRIX_v04.7</span>
              <span className="sf-dossier__sep">▌</span>
              <span className="sf-skills-header__live">
                <span className="sf-dossier__livedot"></span>
                ALL ONLINE
              </span>
            </div>
            <h1 className="sf-skills-header__h1">
              <span className="bg-clip-text text-transparent">{t('skills.title')}</span>
            </h1>
            <p className="sf-skills-header__subtitle">
              <span className="sf-bracket">[</span>
              <span>{t('skills.subtitle')}</span>
              <span className="sf-bracket">]</span>
            </p>
          </header>
        ) : (
          /* NEOBRUTALISM — ARSENAL HEADER */
          <header className="w-full mb-10 sm:mb-12 lg:mb-14">
            <div className="nb-skills-banner">
              <h1 className="nb-skills-banner__h1">★ {t('skills.title').toUpperCase()} ★</h1>
              <p className="nb-skills-banner__subtitle">► {t('skills.subtitle')} ◄</p>
            </div>
          </header>
        )}

        <div className="w-full relative">
          <SkillsGrid />
        </div>
      </div>
    </section>
  );
};

export default MySkills;
